module.exports = __webpack_public_path__ + "media/login-bg.000cdabe.mp4";